// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox--6e9cca","checkbox__control":"checkbox__control--55df2c","checkbox__label":"checkbox__label--296ded"};